import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { PAGE_NAMES } from "@/data/constants";
import { trackPageView } from "@/utils/analytics";
import { Navigation } from "./Navigation";
import { Footer } from "./Footer";

export const Layout: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const pageName = PAGE_NAMES[pathname];
    if (pageName) {
      trackPageView(pathname, pageName);
    }
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col">
      <Navigation />

      <main key={pathname} className="page-enter flex-1">
        <Outlet />
      </main>

      <Footer />
    </div>
  );
};
